import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { renderInputField, renderSelectField } from '../utils/forms'

import { addOperator } from '../actions/operators'
import { fetchCalendars } from '../actions/calendars'
import { fetchRules } from '../actions/rules'
import '../styles/FormModals.css'

class OperatorAddForm extends React.Component {
       constructor(props) {
              super(props)

              this.submit = this.submit.bind(this)
       }

       componentDidMount() {
              const { fetchCalendars, fetchRules } = this.props

              fetchCalendars();
              fetchRules();
       }

       submit(props) {

              return this.props.addOperator(props)
                     .then(response => {
                            if (response.error) {
                                   throw new SubmissionError({
                                          _error: response.error.message,
                                          ...response.error.fields
                                   })
                            }

                            // If in modal mode, close modal and refresh the list
                            if (this.props.isModal) {
                                   this.props.closeModal();
                                   if (this.props.refreshOperators) {
                                          this.props.refreshOperators();
                                   }
                            }

                            return response
                     })
       }

       renderRules(props, rules) {
              const { fields } = props

              return (
                     <div>
                            <div className="opform-rules">
                                   {fields.map((registerrule, index) => (
                                          <div className="opform-rule-row" key={index}>
                                                 <span className="opform-rule-index">{index + 1}</span>
                                                 <div className="opform-rule-field">
                                                        <Field name={`${registerrule}.BusinessRule`}
                                                               component={renderSelectField}
                                                        >
                                                               {rules &&
                                                                      rules
                                                                             .sort((a, b) => a.Name.localeCompare(b.Name))
                                                                             .map((rule) => (
                                                                                    <option value={rule._id} key={rule._id}>
                                                                                           {rule.Name}
                                                                                    </option>
                                                                             ))}
                                                        </Field>
                                                 </div>
                                                 <button className="opform-rule-remove" type="button"
                                                        onClick={() => fields.remove(index)}>
                                                        <i className="fas fa-trash"></i>
                                                 </button>
                                          </div>
                                   ))}
                            </div>
                            <div className="text-right">
                                   <button className="btn btn-vw opform-add-rule" type="button"
                                          onClick={() => fields.push({})}>
                                          <i className="fas fa-plus mr-1"></i>
                                          Añadir
                                   </button>
                            </div>
                     </div>
              )
       }

       render() {
              const { calendars, error, pristine, submitting, handleSubmit, rules, isModal } = this.props

              if (!calendars || !rules) {
                     return (
                            <LoadingProgress />
                     )
              }

              return (
                     <form className="opform" onSubmit={handleSubmit(this.submit)}>
                            {!isModal && (
                                   <h1>
                                          <span className="text-vw-dark">AGREGADOR </span>
                                          <span className="text-vw-light">NUEVO</span>
                                   </h1>
                            )}

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-handshake"></i>
                                          Agregador
                                   </div>
                                   <div className="opform-grid">
                                          <Field name="Name"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="Nombre del agregador" />
                                          <Field name="InvoiceType"
                                                 component={renderSelectField}
                                                 label="Modelo de faturación">
                                                 <option value="">Selecciona un modo...</option>
                                                 <option value="Invoice">Factura</option>
                                                 <option value="Note">Albarán</option>
                                                 <option value="Free">No Contable</option>
                                          </Field>
                                          <Field name="External"
                                                 component={renderSelectField}
                                                 label="Agregador de canal propio Baqueira?">
                                                 <option value="">Selecciona una opción...</option>
                                                 <option value="true">SI</option>
                                                 <option value="false">NO</option>
                                          </Field>
                                          <Field name="Comission"
                                                 type="number"
                                                 component={renderInputField}
                                                 label="Comisión" />
                                          <Field name="Nif"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="NIF/CIF" />
                                          <Field name="Country"
                                                 type="text"
                                                 component={renderInputField}
                                                 label="País" />
                                   </div>
                                   <Field name="Address"
                                          type="text"
                                          component={renderInputField}
                                          label="Dirección" />
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-calendar-alt"></i>
                                          Calendario de precios
                                   </div>
                                   <Field name="Calendar"
                                          component={renderSelectField}
                                          label="Calendario de precios"
                                   >
                                          {calendars &&
                                                 calendars
                                                        .sort((a, b) => a.Name.localeCompare(b.Name))
                                                        .map((calendar) => (
                                                               <option value={calendar._id} key={calendar._id}>
                                                                      {calendar.Name}
                                                               </option>
                                                        ))}
                                   </Field>
                            </div>

                            <div className="opform-section">
                                   <div className="opform-section-title">
                                          <i className="fas fa-pencil-ruler"></i>
                                          Reglas de negocio
                                   </div>
                                   <FieldArray name="BusinessRules" component={(fieldArrayProps) => this.renderRules(fieldArrayProps, rules)} />
                            </div>

                            {error && <div className="alert alert-danger">{error}</div>}

                            {!isModal && (
                                   <button className="btn btn-vw opform-submit" type="submit"
                                          disabled={pristine || submitting}>
                                          <i className="fas fa-save mr-2"></i>
                                          Guardar
                                   </button>
                            )}
                            {isModal && (
                                   <div className="opform-footer">
                                          <button
                                                 className="btn btn-secondary"
                                                 type="button"
                                                 onClick={this.props.closeModal}>
                                                 <i className="fas fa-times mr-2"></i>
                                                 Cancelar
                                          </button>
                                          <button
                                                 className="btn btn-vw"
                                                 type="submit"
                                                 disabled={pristine || submitting}>
                                                 <i className="fas fa-save mr-2"></i>
                                                 Guardar
                                          </button>
                                   </div>
                            )}
                     </form>
              )
       }
}

OperatorAddForm = reduxForm({
       form: 'OperatorAddForm',
       keepDirtyOnReinitialize: true,
       enableReinitialize: true,
       updateUnregisteredFields: true,
       onSubmitSuccess: (result, dispatch, props) => {
              // Only push to route if NOT in modal mode
              if (!props.isModal) {
                     props.push(`/operators/${result.response._id}`)
              }
       }
})(OperatorAddForm)

const mapStateToProps = state => ({
       auth: state.auth,
       role: state.auth.role,
       type: state.auth.type,
       fullname: state.auth.fullname,
       calendars: state.calendars.calendars,
       rules: state.rules.rules,
})

const mapDispatchToProps = dispatch => ({
       addOperator: bindActionCreators(addOperator, dispatch),
       fetchCalendars: bindActionCreators(fetchCalendars, dispatch),
       fetchRules: bindActionCreators(fetchRules, dispatch),
       push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OperatorAddForm)
